import React from 'react'
import Card from '../shared/card/card.jsx'

const JobActivityTask = ({card}) => {
  let backgroundColorHex = card.backgroundColor
  let textColorHex = card.textColor

  return (
    <Card
      textColorHex={textColorHex}
      backgroundColorHex={backgroundColorHex}
      headerTitle={card.title}
      additionalClasses={'no-shadow history-pull-down'}
      headerContent={card.content}
      textMidIcon={card.date}>
      <p dangerouslySetInnerHTML={{ __html: card.content }} />
    </Card>
  )
}

JobActivityTask.propTypes = {
  card: React.PropTypes.object.isRequired
}

export default JobActivityTask



// WEBPACK FOOTER //
// ./src/components/history/job-activity-task.jsx